import linkedin from '../assets/linkedin-in.svg';
import github from '../assets/github.svg';
import codewars from '../assets/cib-codewars.svg';

export const data = [
    {
        id: 1,
        name: 'linkedin',
        logo: linkedin,
        url: 'https://it.linkedin.com/in/giuseppe-conti-4a806b16/',
    },
    {
        id: 2,
        name: 'github',
        logo: github,
        url: 'https://github.com/peppeconti',
    },
    {
        id: 3,
        name: 'codewars',
        logo: codewars,
        url: 'https://www.codewars.com/users/Syphante',
    }
]
